import urls from '@/networkRequests/apiClient/endpoints'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getFulfillmentOrderDetailsForAdminApi } from './getFulfillmentOrderDetailsForAdmin.api'
import getFulfillmentOrderDetailsForAdminInitialState from './getFulfillmentOrderDetailsForAdmin.initialState'
import {
  GetFulfillmentOrderDetailsForAdminErrorResponse,
  GetFulfillmentOrderDetailsForAdminRequestPayload
} from './getFulfillmentOrderDetailsForAdmin.types'

export const getFulfillmentOrderDetailsForAdmin = createAsyncThunk(
  urls.admin.getFulfillmentOrderDetailsForAdmin,
  async (payload: GetFulfillmentOrderDetailsForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getFulfillmentOrderDetailsForAdminApi(request)

      if (onSuccess) {
        onSuccess()
      }

      return response
    } catch (error) {
      return rejectWithValue(error as ApiErrorResponse)
    }
  }
)

const getFulfillmentOrderDetailsForAdminSlice = createSlice({
  name: 'getFulfillmentOrderDetailsForAdmin',
  initialState: getFulfillmentOrderDetailsForAdminInitialState,
  reducers: {
    resetGetFulfillmentOrderDetailsForAdmin: () => getFulfillmentOrderDetailsForAdminInitialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFulfillmentOrderDetailsForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getFulfillmentOrderDetailsForAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.success = action.payload
      })
      .addCase(getFulfillmentOrderDetailsForAdmin.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as GetFulfillmentOrderDetailsForAdminErrorResponse
        errorHandler.handleApiError(action.payload as GetFulfillmentOrderDetailsForAdminErrorResponse, undefined, true)
      })
  }
})

export const getFulfillmentOrderDetailsForAdminActions = {
  ...getFulfillmentOrderDetailsForAdminSlice.actions,
  getFulfillmentOrderDetailsForAdmin
}

export default getFulfillmentOrderDetailsForAdminSlice.reducer
